import Base from "./base.service.js";
export default class PaymentMethod extends Base {
    constructor() {
        super("payment-method");
    }
}
